import { Select } from "antd";
import React, { useEffect, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const NewCreditNote = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const navigate = useNavigate();

  const { state } = useLocation();

  console.log(state, "state................................");

  console.log("Customer ID:", state?.customerId);

  const customermainid = state?.customerId;
  console.log(customermainid);

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [discountOptions, setDiscountOptions] = useState([]);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);

  const [currencies, setCurrencies] = useState([]);
  const [currencyLoading, setCurrencyLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [taxOptions, setTaxOptions] = useState([]);
  const [taxLoading, setTaxLoading] = useState(false);

  const [itemOptions, setItemOptions] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  const [discountType, setDiscountType] = useState("before");

  const [discount, setDiscount] = useState(0);
  const [adjustment, setAdjustment] = useState(0);

  const [items, setItems] = useState([]);

  console.log(items,itemLoading,taxLoading,"items.........................")

  const [quantityOption, setQuantityOption] = useState("Qty");

  const [openDiscountDropdown, setOpenDiscountDropdown] = useState(false);

  const [isCustomerPrefilled, setIsCustomerPrefilled] = useState(false);

  const [creditsaveloading,setCreditsaveloading] = useState(false);
  console.log(openDiscountDropdown);



  const [formData, setFormData] = useState({
    adminnote: "",
    clientnote: "",
    terms:
      "1) Warranty: 12 months from the date of installation. The materials are not covered if they fail due to power fluctuation, accidents, or physical damages. 2) Devices once installed or used will not be taken back (No Refund).",
    date: "",
    reference_no: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: null,

    project_id: null,
    adjustment: 0,
    currency: null,
  });

  useEffect(() => {
    if (!state) return;

    if (state.type === "customer") {
      const customer = state.record;

      // Select "Customer" in Related dropdown

      setSelectedCustomer({
        value: customer.customerId,
        label: customer.company,
      });
      if (state.type === "customer") {
        fillCustomerDetails(state.record);
        setIsCustomerPrefilled(true);
      }
    }
  }, [state, countries]);

  const fillCustomerDetails = (customer) => {
    console.log("Customer Data.........:", customer);
    setFormData((prev) => ({
      ...prev,
      street: customer.address || "",
      city: customer.billing_city || "",
      state: customer.billing_state || "",
      zip: customer.billing_zip || "",
      country: customer.billing_country || null,
      currency: customer.default_currency,
    }));

    setSelectedCurrency(
      currencies.find(
        (item) => Number(item.value) === Number(customer.default_currency)
      ) || null
    );

    setSelectedCountry(
      countries.find((c) => c.value === customer.billing_country) || null
    );

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };

  const getCustomerDetails = async (customerId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length > 0) {
        fillCustomerDetails(data.ResultData[0]);
        setIsCustomerPrefilled(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCurrencies = async () => {
    try {
      setCurrencyLoading(true);

      const response = await fetch(`${BASE_CRM_URL}expenses/GetCurrencies`);
      const data = await response.json(); // <-- Parse JSON

      console.log(data);

      if (data.Status) {
        const options = data.Data.map((item) => ({
          value: item.id,
          label: `${item.symbol} ${item.name}`,
        }));

        console.log(options);

        setCurrencies(options);

        if (options.length > 0) {
          setSelectedCurrency(options[1].value);
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);

        // Optional: Set India as default if available
        const india = options.find((item) => item.label === "India");

        if (india) {
          setSelectedCountry(india.value);
        } else if (options.length > 0) {
          setSelectedCountry(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getDiscountTypes = async () => {
    try {
      setDiscountLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetDescountTypes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.TaxType,
        }));

        setDiscountOptions(options);

        // Optional: Set first option as default
        if (options.length > 0) {
          setSelectedDiscountType(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching discount types:", error);
    } finally {
      setDiscountLoading(false);
    }
  };

  const getProducts = async () => {
    try {
      setItemLoading(true);

      const response = await fetch(`${BASE_CRM_URL}products/GetProducts`);
      const data = await response.json();

      if (data.Status) {
        const products = data.Data.map((item) => ({
          id: item.id,
          item: item.description,
          description: item.long_description || item.description,
          hsn: "",
          qty: 1,
          rate: parseFloat(item.rate),
          amount: parseFloat(item.rate),
          unit: item.unit,

          tax: item.tax,
          tax2: item.tax2,

          tax_id: item.tax_id,
          tax2_id: item.tax2_id,

          tax_name: item.tax_name,
          tax2_name: item.tax2_name,
        }));

        setItemOptions(products);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setItemLoading(false);
    }
  };

  const getTaxes = async () => {
    try {
      setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate),
        }));

        setTaxOptions(options);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
    } finally {
      setTaxLoading(false);
    }
  };

  useEffect(() => {
    getCurrencies();

    getCountries();
    getDiscountTypes();

    getProducts();
    getTaxes();
    getCustomers();
  }, []);

  const addItem = (item) => {
    const newItem = {
      id: Date.now(),
      ...item,
      selectedTaxes: item.selectedTaxes || [],
      taxes: [],
      isSaved: false,
    };

    setItems((prev) => [...prev, newItem]);
  };
  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const saveItem = (id) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;

        return {
          ...item,
          taxes: item.selectedTaxes,
          isSaved: true,
        };
      })
    );
  };

  const calculateSubtotal = () => {
    return items.reduce((sum, item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      return sum + qty * Number(item.rate || 0);
    }, 0);
  };
  const calculateDiscount = (amount) => {
    return (amount * discount) / 100;
  };
  const subtotal = calculateSubtotal();

  const discountAmount = calculateDiscount(subtotal);

  const calculateTaxes = () => {
    const taxSummary = {};

    items.forEach((item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      const amount = qty * Number(item.rate || 0);

      (item.taxes || []).forEach((tax) => {
        const taxAmount = (amount * Number(tax.taxrate || 0)) / 100;

        if (!taxSummary[tax.label]) {
          taxSummary[tax.label] = {
            name: tax.label,
            amount: 0,
          };
        }

        taxSummary[tax.label].amount += taxAmount;
      });
    });

    // Return ARRAY instead of OBJECT
    return Object.values(taxSummary);
  };

  const totalTax = calculateTaxes().reduce(
    (sum, tax) => sum + tax.amount,

    0
  );

  const calculateTotal = () => {
    let total;

    if (discountType === "before") {
      total = subtotal - discountAmount + totalTax + adjustment;
    } else {
      total = subtotal + totalTax - discountAmount + adjustment;
    }

    return total;
  };

  const addCreditNote = async (e) => {
    e.preventDefault();
  

    try {
      setCreditsaveloading(true)

      const payload = {
        clientid: selectedCustomer?.value,
        prefix: "CN-",
        number_format: 0,
        date: formData.date,
        adminnote: formData.adminnote,
        clientnote: formData.clientnote,
        terms: formData.terms,
        currency: selectedCurrency?.value || 5,
        subtotal: calculateSubtotal(),
        total_tax: calculateTaxes().reduce((sum, tax) => sum + tax.amount, 0),
        total: calculateTotal(),
        adjustment: Number(formData.adjustment || 0),
        addedfrom: userId,
        status: 1,
        project_id: 0,
        discount_percent: Number(discount || 0),
        discount_total: Number(discountAmount || 0),
        discount_type: selectedDiscountType?.label || "",

        billing_street: formData.street,
        billing_city: formData.city,
        billing_state: formData.state,
        billing_zip: formData.zip,
        billing_country: selectedCountry?.value,

        shipping_street: "",
        shipping_city: "",
        shipping_state: "",
        shipping_zip: "",
        shipping_country: selectedCountry?.value,

        include_shipping: 0,
        show_shipping_on_credit_note: 0,
        show_quantity_as: 1,

        reference_no: formData.reference_no,

        items: items.map((item, index) => ({
          description: item.item,
          long_description: item.description,
          qty: Number(item.qty),
          rate: Number(item.rate),
          unit: item.unit,
          item_order: index + 1,

          taxes: (item.taxes || []).map((tax) => ({
            taxname: tax.taxname,
            taxrate: Number(tax.taxrate),
          })),
        })),
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}creditnotes/AddCreditNote`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("After API", response);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        });

        console.log(response.data);
        navigate("/crm/creditnotes");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message,
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error(error);

      console.error(
        error.response?.data?.Message || "Failed to add Credit Note."
      );
    }finally{
      setCreditsaveloading(false)
    }
  };

  return (
    <>
      <style>
        {`
      .prefilled-select .ant-select-selector {
        background-color: #fff8db !important;
        border: 1px solid #ffc107 !important;
      }
      
      `}
      </style>
      <div className="page-wrapper">
        <div className="content">
          <div className="container mt-2">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/crm/Dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        New Credit Notes
                      </h4>
                    </ol>
                  </nav>
                  <h6>Manage your New Credit Notes here</h6>
                </div>
              </div>
              <ul className="table-top-head"></ul>
              <div className="page-btn">
                <Link to="/crm/creditnotes" className="btn btn-dark btn-sm">
                  <i className="ti ti-arrow-left"></i>
                </Link>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <form onSubmit={addCreditNote}>
                  <div className="row">
                    <div className="mb-2 col-3">
                      <label>Customer</label>
                      <Select
                        showSearch
                        placeholder="Select Customer"
                        optionFilterProp="label"
                        className={`w-100 ${
                          isCustomerPrefilled ? "prefilled-select" : ""
                        }`}
                        style={{ height: 38 }}
                        options={customerOptions}
                        value={selectedCustomer}
                        onChange={(value) => {
                          setSelectedCustomer(value);
                          getCustomerDetails(value);
                        }}
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>Credit Note Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={formData.date}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            date: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>Reference #</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Reference #"
                        value={formData.reference_no || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            reference_no: e.target.value,
                          }))
                        }
                        required
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label> (Bill To) Street</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Street"
                        value={formData.street}
                        onChange={(e) =>
                          setFormData({ ...formData, street: e.target.value })
                        }
                        style={{
                          backgroundColor: selectedCustomer
                            ? "#fff8db"
                            : "#fff",
                        }}
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>City</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter City"
                        value={formData.city}
                        onChange={(e) =>
                          setFormData({ ...formData, city: e.target.value })
                        }
                        style={{
                          backgroundColor: selectedCustomer
                            ? "#fff8db"
                            : "#fff",
                        }}
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>State</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter State"
                        value={formData.state}
                        onChange={(e) =>
                          setFormData({ ...formData, state: e.target.value })
                        }
                        style={{
                          backgroundColor: selectedCustomer
                            ? "#fff8db"
                            : "#fff",
                        }}
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>Zip Code</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Zip Code"
                        value={formData.zip}
                        onChange={(e) =>
                          setFormData({ ...formData, zip: e.target.value })
                        }
                        style={{
                          backgroundColor: selectedCustomer
                            ? "#fff8db"
                            : "#fff",
                        }}
                      />
                    </div>

                    <div className="mb-2 col-3">
                      <label>Country</label>
                      <Select
                        className={`w-100 ${
                          isCustomerPrefilled ? "prefilled-select" : ""
                        }`}
                        style={{ height: 38 }}
                        placeholder="Select Country"
                        options={countries}
                        value={selectedCountry}
                        loading={countryLoading}
                        onChange={(value) => {
                          setSelectedCountry(value);
                          setIsCustomerPrefilled(false);
                        }}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </div>
                    <div className="mb-1 col-12">
                      <label>Admin Note</label>
                      <textarea
                        className="form-control"
                        placeholder="Enter text here"
                        rows="1"
                        value={formData.adminnote}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            adminnote: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* <div className="col-md-1 d-flex align-items-center justify-content-center">
                    <div
                      style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        height: "100%",
                      }}
                    />
                  </div> */}
                  {/* <div className="col-md-6">
                    <div className="row">
                     

                      <h6 className="fw-bold">Bill To</h6>

                   
                      <div className="col-md-6 d-none">
                        <h6 className="fw-bold mb-3">Ship To</h6>

                        <div className="mb-3">
                          <label >Street</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Street"
                          />
                        </div>

                        <div className="mb-3">
                          <label >City</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter City"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">State</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter State"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Zip Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Zip Code"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Country</label>
                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            placeholder="Select Country"
                            options={countries}
                            value={selectedCountry}
                            loading={countryLoading}
                            onChange={(value) => setSelectedCountry(value)}
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <hr />

                  <div className="row">
                    <div className=" mb-3 col-4">
                      <Select
                        className="w-100"
                        showSearch
                        placeholder="Select Item"
                        style={{ height: 38 }}
                        optionFilterProp="label"
                        options={itemOptions.map((option) => ({
                          value: option.id,
                          label: option.item,
                          ...option, // include all properties
                        }))}
                        // loading={itemLoading}
                        onChange={(selectedValue, selectedOption) => {
                          if (!selectedOption) return;

                          addItem({
                            item: selectedOption.item,
                            description: selectedOption.description,
                            hsn: selectedOption.hsn,
                            qty: selectedOption.qty,
                            rate: selectedOption.rate,
                            amount: selectedOption.amount,
                            unit: selectedOption.unit,
                            productId: selectedOption.id,
                            tax: selectedOption.tax,

                            selectedTaxes: taxOptions.filter(
                              (tax) =>
                                Number(tax.value) ===
                                  Number(selectedOption.tax) ||
                                Number(tax.value) ===
                                  Number(selectedOption.tax2)
                            ),
                          });
                        }}
                      />
                    </div>
                    <div className="col-4">
                      <div className="d-flex justify-content-end col-4 d-none">
                        <fieldset>
                          <label>
                            <b>Show quantity as:</b>
                          </label>
                          <div className="form-check ms-2 form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="quantityOptions"
                              id="qty"
                              value="Qty"
                              checked={quantityOption === "Qty"}
                              onChange={() => setQuantityOption("Qty")}
                            />
                            <label className="form-check-label" htmlFor="qty">
                              Qty
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="quantityOptions"
                              id="hours"
                              value="Hours"
                              checked={quantityOption === "Hours"}
                              onChange={() => setQuantityOption("Hours")}
                            />
                            <label className="form-check-label" htmlFor="hours">
                              Hours
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="quantityOptions"
                              id="qtyHours"
                              value="Qty/Hours"
                              checked={quantityOption === "Qty/Hours"}
                              onChange={() => setQuantityOption("Qty/Hours")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="qtyHours"
                            >
                              Qty/Hours
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end col-4 gap-2">
                      <div className="mb-3 col-6">
                        <Select
                          showSearch
                          placeholder="Select Currency"
                          optionFilterProp="label"
                          className="w-100"
                          style={{ height: 38 }}
                          options={currencies}
                          value={selectedCurrency}
                          loading={currencyLoading}
                          onChange={(value) => setSelectedCurrency(value)}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </div>
                      {discount > 0 && (
                        <div className="mb-3 col-6">
                          <Select
                            showSearch
                            placeholder="Select Discount Type"
                            optionFilterProp="label"
                            className="w-100"
                            style={{ height: 38 }}
                            options={discountOptions}
                            value={selectedDiscountType}
                            loading={discountLoading}
                            onChange={(value, option) => {
                              setSelectedDiscountType(value);
                              setDiscountType(
                                option.value === 1 ? "before" : "after"
                              );
                            }}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="table-responsive mt-2">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Item</th>
                          <th>Description</th>
                          <th>HSN</th>
                          <th>
                            {quantityOption === "Qty" && "Qty"}
                            {quantityOption === "Hours" && "Hours"}
                            {quantityOption === "Qty/Hours" && "Qty/Hours"}
                          </th>
                          <th>Rate</th>
                          <th>Tax</th>
                          <th>Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        ) : (
                          items.map((item) => {
                            const quantity =
                              quantityOption === "Hours"
                                ? item.hours
                                : item.qty;
                            const total = (quantity || 0) * (item.rate || 0);
                            // const taxAmount = (total * parseFloat(item.tax)) / 100;
                            const taxAmount =
                              (total * Number(item.taxRate || 0)) / 100;

                            const rowTotal = total + taxAmount;

                            return (
                              <tr key={item.id}>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.item}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.description}
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    disabled={item.isSaved}
                                    className="form-control"
                                    value={item.hsn}
                                    onChange={(e) =>
                                      setItems(
                                        items.map((i) =>
                                          i.id === item.id
                                            ? { ...i, hsn: e.target.value }
                                            : i
                                        )
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  {quantityOption === "Qty" ||
                                  quantityOption === "Qty/Hours" ? (
                                    <input
                                      type="number"
                                      disabled={item.isSaved}
                                      className="form-control"
                                      value={item.qty}
                                      onChange={(e) =>
                                        setItems(
                                          items.map((i) =>
                                            i.id === item.id
                                              ? { ...i, qty: e.target.value }
                                              : i
                                          )
                                        )
                                      }
                                    />
                                  ) : quantityOption === "Hours" ? (
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={item.hours}
                                      onChange={(e) =>
                                        setItems(
                                          items.map((i) =>
                                            i.id === item.id
                                              ? { ...i, hours: e.target.value }
                                              : i
                                          )
                                        )
                                      }
                                    />
                                  ) : null}
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    disabled={item.isSaved}
                                    className="form-control"
                                    value={item.rate}
                                    onChange={(e) =>
                                      setItems(
                                        items.map((i) =>
                                          i.id === item.id
                                            ? { ...i, rate: e.target.value }
                                            : i
                                        )
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  {item.isSaved ? (
                                    <div className="d-flex flex-wrap gap-1">
                                      {item.taxes.map((tax) => (
                                        <span
                                          key={tax.value}
                                          className="badge bg-success"
                                        >
                                          {tax.label}
                                        </span>
                                      ))}
                                    </div>
                                  ) : (
                                    <Select
                                      isMulti
                                      closeMenuOnSelect={false}
                                      options={taxOptions}
                                      value={item.selectedTaxes}
                                      placeholder="Select Tax"
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      styles={{
                                        valueContainer: (base) => ({
                                          ...base,
                                          flexWrap: "nowrap",
                                          overflowX: "auto",
                                          scrollbarWidth: "none",
                                        }),
                                        multiValue: (base) => ({
                                          ...base,
                                          minWidth: "fit-content",
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      onChange={(value) => {
                                        setItems((prev) =>
                                          prev.map((row) =>
                                            row.id === item.id
                                              ? {
                                                  ...row,
                                                  selectedTaxes: value || [],
                                                }
                                              : row
                                          )
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td>{rowTotal.toFixed(2)}</td> {/* Row total */}
                                <td>
                                  {!item.isSaved && (
                                    <button
                                      className="btn btn-success btn-sm me-2"
                                      onClick={() => saveItem(item.id)}
                                    >
                                      <i className="fa-solid fa-check"></i>
                                    </button>
                                  )}

                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteItem(item.id)}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Subtotal, Discount, IGST, and Total */}
                  <div className="row mt-2">
                    <div className="col-md-8">
                      <div>
                        <label className="form-label">Client Note</label>
                        <textarea
                          className="form-control"
                          rows="2"
                          value={formData.clientnote}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              clientnote: e.target.value,
                            }))
                          }
                        />
                      </div>

                      {/* Terms & Conditions */}
                      <div className="mt-3">
                        <label className="form-label">Terms & Conditions</label>
                        <textarea
                          className="form-control"
                          rows="2"
                          value={formData.terms}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              terms: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <span>Sub Total:</span>
                          <span>Rs.{calculateSubtotal().toFixed(2)}</span>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1 d-none">
                        <div className="d-flex justify-content-between">
                          <span>Discount:</span>
                          <div className="" style={{ width: "30%" }}>
                            <select
                              className="form-select"
                              value={discount}
                              onChange={(e) => {
                                setDiscount(Number(e.target.value));

                                if (Number(e.target.value) > 0) {
                                  setOpenDiscountDropdown(true);
                                }
                              }}
                            >
                              <option value={0}>0%</option>
                              <option value={5}>5%</option>
                              <option value={10}>10%</option>
                              <option value={15}>15%</option>
                              <option value={20}>20%</option>
                            </select>
                          </div>
                          <span>
                            -Rs.
                            {calculateDiscount(calculateSubtotal()).toFixed(2)}
                          </span>
                        </div>
                        <hr />
                      </div>

                      {items.map((item, index) => {
                        const qty =
                          quantityOption === "Hours"
                            ? Number(item.hours || 0)
                            : Number(item.qty || 0);

                        const amount = qty * Number(item.rate || 0);

                        return (
                          <div key={item.id || index}>
                            <div className="fw-bold mb-1">{item.item}</div>

                            {(item.taxes || []).map((tax) => {
                              const taxAmount =
                                (amount * Number(tax.taxrate || 0)) / 100;

                              return (
                                <div
                                  key={`${item.id}-${tax.value}`}
                                  className="d-flex justify-content-between ms-3"
                                >
                                  <span>{tax.label}</span>
                                  <span>Rs. {taxAmount.toFixed(2)}</span>
                                </div>
                              );
                            })}

                            <hr />
                          </div>
                        );
                      })}

                      <div className="mb-1">
                        <div className="d-flex justify-content-between">
                          <span>Adjustment:</span>
                          <div style={{ width: "30%" }}>
                            <input
                              type="number"
                              className="form-control ms-1"
                              value={adjustment}
                              onChange={(e) =>
                                setAdjustment(parseFloat(e.target.value))
                              }
                            />
                          </div>
                          <span>Rs.{adjustment.toFixed(2)}</span>
                        </div>
                        <hr />
                      </div>

                      <div className="mb-1">
                        <div className="d-flex justify-content-end">
                          <strong>Total:</strong>
                          <strong> Rs.{calculateTotal().toFixed(2)}</strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />
                  {/* Client Note */}

                  <div className="mt-3 d-flex justify-content-end">
                    {/* Save Button */}
                    <button className="btn btn-success ">Save & Send</button>
                    <button
                      type="button"
                      className="btn btn-primary ms-3"
                    onClick={addCreditNote}
                      disabled={creditsaveloading}
                    >
                      {creditsaveloading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <>
        <BillTo />
      </> */}
      </div>
    </>
  );
};

export default NewCreditNote;
